/**
 * Staff (dashboard operator) constants — per Kiran 2026-05-14.
 *
 * Drives the /iam/staff CRUD flow and the staff-welcome first-login
 * password reset. `iam_users` is the underlying table.
 *
 * Naming + bounds mirror the existing customer signup path so the
 * staff flow doesn't drift over time.
 */

/**
 * Fixed initial password every new staff user gets. The
 * welcome-email body shows this value so staff knows their current
 * password; the welcome page REJECTS submissions equal to this string
 * so staff is forced to choose a different one.
 *
 * Per Rule #23: this is a literal that affects the wire (hashed and
 * stored in iam_users.password_hash on every create + referenced in
 * the email template + checked in the welcome handler). NOT a tuning
 * knob — code-only, rotation requires a code release.
 */
export const STAFFDEFAULTPASSWORD = 'Uyyamadilu@123'

/** Max length for first_name + last_name on staff create/edit. */
export const STAFFNAMEMAX = 64

/**
 * User-type codes that the staff form's user_type DDL must HIDE.
 * Per Kiran 2026-05-14: "should be able to select all except admin
 * and customer from user type" — admin is super-admin (created via
 * seed/CLI, not the staff screen) and customer is the storefront
 * shopper identity (created via /account/register).
 */
export const STAFFFORBIDDENUSERTYPES = ['admin', 'customer'] as const

/**
 * Welcome token — random bytes that map to the new staff's email in
 * SESSION_KV. The token is the auth credential the staff uses on the
 * welcome page to set their real password. Single-use (deleted on
 * success), TTL-bounded.
 */
export const STAFFWELCOMETOKENBYTES = 32
export const STAFFWELCOMETOKENTTLSECS = 86400 // 24 hours
